const state = {
  visible: false,
  type: null,
  message: null,
};

const mutations = {
  success: (state, message) => {
    state.visible = true;
    state.type = 'success';
    state.message = message;
  },
  warning: (state, message) => {
    state.visible = true;
    state.type = 'warning';
    state.message = message;
  },
  error: (state, message) => {
    state.visible = true;
    state.type = 'error';
    state.message = message;
  },
  clear: (state) => {
    state.visible = false;
    state.type = null;
    state.message = null;
  }
};

const actions = {
  success({ commit }, message) {
    commit('success', message);
  },
  warning({ commit }, message) {
    commit('warning', message);
  },
  error({ commit }, message) {
    commit('error', message);
  },
  clear({ commit }) {
    commit('clear');
  },
};

const getters = {
  alert (state) {
    return state
  },
};

const alert = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};

export default alert;